import { render, staticRenderFns } from "./ManageSpaces.vue?vue&type=template&id=7fc07c42"
import script from "./ManageSpaces.vue?vue&type=script&lang=js"
export * from "./ManageSpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports